module.exports = __webpack_public_path__ + "media/images/landing__teaser__applicationImage-9cf2822252df8cfaf7bfc122212f604c.png";